/**************************************************
 * Nombre:       Footer
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import Footer_Llamado from "./Componentes/Footer_Llamado";
import {theme} from "../../Tema";
import logo from '../../Recursos/logo_blanco.svg'
import {CONTACTOS, NEGRITA, SECCIONES} from "../../Constantes";
import {useContext} from "react";
import {contexApp} from "../../App";
import {useDialogo} from "../../Modulo_Dialogos_2025/Hooks/useDialogo";
import Dialogo_Politicas from "../Dialogos/Dialogo_Politicas";
import {useNavigate} from "react-router";
import {useIrRuta} from "../../Utilidades/useIrRuta";
import {useResponsive} from "../../Modulo_responsive/Hooks/useResponsive";


const Footer = () => {
    const {sCell, sTab} = useResponsive()
    const navigate = useNavigate();
    const adicionales = useContext(contexApp).adicionales
    const {ir} = useIrRuta()
    const {Dialogo, abrir} = useDialogo({Componente: Dialogo_Politicas})

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundColor: theme.palette.primary.main,
                pt: 20,
                mt: 24
            }}
        >

            <Dialogo/>

            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff', pb: 8}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 11}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'flex-start'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={3}
                    >


                        {!sTab &&
                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: 'flex-start', mt: -38, pb: 10}}>
                                <Footer_Llamado/>
                            </Grid>
                        }


                        <Grid
                            container
                            justifyContent={'center'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 6, md: 3}}
                            spacing={0}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}}
                                  sx={{justifyContent: sCell ? 'center' : 'flex-start'}}>
                                <img src={logo} width={250} height={'auto'} alt={'logo'}/>
                            </Grid>

                            <Grid container size={{xs: 8, sm: 12, md: 12}}
                                  sx={{justifyContent: 'flex-start', mt: sCell ? 1 : 3}}>
                                <Typography sx={{fontSize: 14, fontWeight: 300, textAlign: sCell ? 'center' : 'left'}}>
                                    El diálogo abre caminos, la conciliación construye paz.
                                </Typography>
                            </Grid>


                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 6, md: 2}}
                            spacing={0}
                            sx={{mt: sCell ? 2 : 0}}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontFamily: NEGRITA, fontSize: 16, fontWeight: 400}}>LINKS
                                    RÁPIDOS</Typography>
                            </Grid>


                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{mt: 2}}
                            >

                                {SECCIONES.map((it, index) => (
                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', mt: 1}}>
                                        <Typography
                                            onClick={() => ir(it)}
                                            sx={{
                                                fontSize: 14,
                                                borderBottom: 1,
                                                borderColor: '#ffffff00',
                                                cursor: 'pointer',
                                                transition: 'all .2s ease-in-out',
                                                "&:hover": {
                                                    borderColor: '#ffffff',
                                                }
                                            }}>
                                            {it}
                                        </Typography>
                                    </Grid>
                                ))}

                            </Grid>

                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 6, md: 4}}
                            spacing={0}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontFamily: NEGRITA, fontSize: 16, fontWeight: 400}}>
                                    CONTACTOS
                                </Typography>
                            </Grid>


                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{mt: 2}}
                            >

                                {CONTACTOS.map((it, index) => (
                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', mt: 1}}>
                                        <Typography sx={{
                                            fontSize: 14,
                                            borderBottom: 1,
                                            borderColor: '#ffffff00',
                                            cursor: 'pointer',
                                            transition: 'all .2s ease-in-out',
                                            "&:hover": {
                                                borderColor: '#ffffff',
                                            }
                                        }}>

                                            {it.nombre !== 'Correo' &&
                                                <img src={it.img} width={12} height={'auto'} alt={'logo'}
                                                     style={{marginRight: 6}}/>
                                            }
                                            {it.descripcion}
                                        </Typography>
                                    </Grid>
                                ))}

                            </Grid>

                        </Grid>

                        <Grid
                            container
                            justifyContent={'flex-start'}
                            alignItems={'flex-start'}
                            size={{xs: 12, sm: 6, md: 2}}
                            spacing={0}
                        >

                            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start'}}>
                                <Typography sx={{fontFamily: NEGRITA, fontSize: 16, fontWeight: 400}}>
                                    ENLACES ADICIONALES
                                </Typography>
                            </Grid>


                            <Grid
                                container
                                justifyContent={'flex-start'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                sx={{mt: 2}}
                            >

                                {adicionales.map((it, index) => (
                                    <Grid container size={{xs: 12, sm: 12, md: 12}}
                                          sx={{justifyContent: 'flex-start', mt: 1}}>
                                        <Typography
                                            onClick={() => abrir(it)}
                                            sx={{
                                                fontSize: 14,
                                                borderBottom: 1,
                                                borderColor: '#ffffff00',
                                                cursor: 'pointer',
                                                transition: 'all .2s ease-in-out',
                                                "&:hover": {
                                                    borderColor: '#ffffff',
                                                }
                                            }}>


                                            {it.titulo}
                                        </Typography>
                                    </Grid>
                                ))}

                                <Grid container size={{xs: 12, sm: 12, md: 12}}
                                      sx={{justifyContent: 'flex-start', mt: 1}}>
                                    <Typography
                                        onClick={() => navigate('/Tratamiento')}
                                        sx={{
                                            fontSize: 14,
                                            borderBottom: 1,
                                            borderColor: '#ffffff00',
                                            cursor: 'pointer',
                                            transition: 'all .2s ease-in-out',
                                            "&:hover": {
                                                borderColor: '#ffffff',
                                            }
                                        }}>


                                        AUTORIZACIÓN TRATAMIENTO DE DATOS
                                    </Typography>
                                </Grid>

                            </Grid>

                        </Grid>

                    </Grid>
                </Grid>

            </Grid>

            <Grid container size={{xs: 12, sm: 12, md: 12}}
                  sx={{justifyContent: 'center', borderTop: 1, borderColor: '#ffffff50', p: 1}}>
                <Typography sx={{color: '#fff', textAlign: 'center', fontSize: 14}}>© Copyright 2026 - 2027 | Centro de
                    Conciliacion y Arbitraje Soluciones
                    de Conflictos para la Paz </Typography>
            </Grid>

        </Grid>
    )

}
export default Footer